import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import '../App.css';

const LeftSidebar = ({notificationsRefreshKey}) => {
  const [notifications, setNotifications] = useState({ alerts: 0, questions: 0, assets: 0, profiles: 0 });
  const { API_BASE_URL } = useAuth();

  // Função para buscar as notificações
  const fetchNotifications = () => {
    const token = localStorage.getItem('token');
    fetch(`${API_BASE_URL}notifications`, {
      headers: { Authorization: token },
    })
      .then((res) => res.json())
      .then((data) => {
        // Assume que `data` tenha o formato: { questions: 5, assets: 3 }
        setNotifications({
          alerts: data.alerts || 0,
          questions: data.questions || 0,
          assets: data.assets || 0,
          profiles: data.profiles || 0,
        });
      })
      .catch((err) => console.error('Error fetching notifications:', err));
  };

  // Usar o useEffect para buscar as notificações na montagem do componente
  useEffect(() => {
    fetchNotifications();
  }, [notificationsRefreshKey]);

  return (
    <ul className="list-group">
      <li className="list-group-item">
        <Link to="/questions">
          Questions
          {notifications.questions > 0 && (
            <span className="badge-notification" style={{ marginLeft: '8px' }}>
              {notifications.questions}
            </span>
          )}
        </Link>
      </li>
      <li className="list-group-item">
        <Link to="/alerts">
          Alerts
          {notifications.alerts > 0 && (
            <span className="badge-notification" style={{ marginLeft: '8px' }}>
              {notifications.alerts}
            </span>
          )}
        </Link>
      </li>
      <li className="list-group-item">
        <Link to="/assets">
          Assets
          {notifications.assets > 0 && (
            <span className="badge-notification" style={{ marginLeft: '8px' }}>
              {notifications.assets}
            </span>
          )}
        </Link>
      </li>
      <li className="list-group-item">
        <Link to="/profiles">
          Profiles
          {notifications.profiles > 0 && (
            <span className="badge-notification" style={{ marginLeft: '8px' }}>
              {notifications.profiles}
            </span>
          )}
        </Link>
      </li>
      <li className="list-group-item">
        <Link to="/sensors">Sensors</Link>
      </li>
      <li className="list-group-item">
        <Link to="/logs">
          Logs
        </Link>
      </li>
    </ul>
  );
};

export default LeftSidebar;
